import React from 'react';
import { TouchableOpacity, View } from 'react-native';

import { Text } from '../../components';
import { useThemedStyles } from '../../hooks/useThemedStyles';

import { createPickListDetailStyles } from './PickListDetail.styles';

// Voice mode controls, covering everything below the header.
const PickListVoiceOverlay = ({
	banner,
	overlayTopStyle,
	currentVoiceItemIndex,
	onNext,
	onRepeat,
	onPause,
	onQuit,
}) => {
	const styles = useThemedStyles(createPickListDetailStyles);

	return (
		<View style={[styles.overlay, overlayTopStyle]}>
			{/* Keep the training indicator visible over the overlay. */}
			{banner}
			<TouchableOpacity
				onPress={onNext}
				style={styles.voiceNext}
				accessibilityRole="button"
				accessibilityLabel="Next item"
			>
				<Text style={styles.voiceNextLabel}>Next</Text>
			</TouchableOpacity>
			<View style={styles.voiceActions}>
				<TouchableOpacity
					onPress={onRepeat}
					style={[styles.voiceAction, styles.voiceRepeat]}
					disabled={currentVoiceItemIndex === -1}
					accessibilityRole="button"
					accessibilityState={{ disabled: currentVoiceItemIndex === -1 }}
				>
					<Text style={[styles.voiceActionLabel, styles.voiceRepeatLabel, currentVoiceItemIndex === -1 && styles.voiceActionDisabled]}>Repeat</Text>
				</TouchableOpacity>
				<TouchableOpacity
					onPress={onPause}
					style={[styles.voiceAction, styles.voicePause]}
					accessibilityRole="button"
				>
					<Text style={[styles.voiceActionLabel, styles.voicePauseLabel]}>Pause</Text>
				</TouchableOpacity>
				<TouchableOpacity
					onPress={onQuit}
					style={[styles.voiceAction, styles.voiceQuit]}
					accessibilityRole="button"
				>
					<Text style={[styles.voiceActionLabel, styles.voiceQuitLabel]}>Quit</Text>
				</TouchableOpacity>
			</View>
		</View>
	);
};

export default PickListVoiceOverlay;
